import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { V_IOTBOX_DEV_LIST, GetStatuserrorList, IotBoxAlarmData } from './IoTDevList';
import { IoTDevListStyle, TableUseStyle } from './IoTDevListStyle';

type IotDevListStatErrorDialogProps = {
  open: boolean;
  onClose: () => void;
  iotBoxData: V_IOTBOX_DEV_LIST;
};

const IotDevListStatErrorDialog: React.FC<IotDevListStatErrorDialogProps> = (props) => {
  const tableStyle = TableUseStyle();
  const pageStyle = IoTDevListStyle();
  const { t } = useTranslation();
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const [iotBoxAlarmDataList, setIoTBoxAlarmDataList] = useState<IotBoxAlarmData[]>([]);

  useEffect(() => {
    if (props.open === true) {
      setButtonEnable(false);
      console.debug(['IotDevListStatErrorDialog useEffect']);
      GetStatuserrorList(props.iotBoxData.IMSI_NO)
        .then((r) => {
          setIoTBoxAlarmDataList(r);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setButtonEnable(true);
        });
    } else {
      setIoTBoxAlarmDataList([]);
    }
  }, [props.open]);

  /**
   * エラー区分
   * @param sate
   * @returns
   */
  const getAlmKindText = (kind: Number): string => {
    if (kind == undefined) return t('IotDevListStatErrorDialog.不明', '不明');
    switch (kind) {
      case 1:
        return t('IotDevListStatErrorDialog.重故障', '重故障');
      case 2:
        return t('IotDevListStatErrorDialog.軽故障', '軽故障');
      default:
        return t('IotDevListStatErrorDialog.不明', '不明');
    }
  };

  return (
    <>
      <Dialog open={props.open} fullWidth={true} maxWidth={'md'}>
        <DialogTitle id="alert-dialog-title">
          {t('IotDevListStatErrorDialog.ステータスアラームログ', 'ステータスアラームログ')}
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper} className={pageStyle.tableContainer}>
            <Table stickyHeader aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell className={tableStyle.headerCell}>
                    {' '}
                    {t('IotDevListStatErrorDialog.区分', '区分')}
                  </TableCell>
                  <TableCell className={tableStyle.headerCell}>
                    {t('IotDevListStatErrorDialog.項目名称', '項目名称')}
                  </TableCell>
                  <TableCell className={tableStyle.headerCell}>
                    {t('IotDevListStatErrorDialog.異常内容', '異常内容')}
                  </TableCell>
                  <TableCell className={tableStyle.headerCell}>
                    {t('IotDevListStatErrorDialog.メッセージ', 'メッセージ')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {iotBoxAlarmDataList.map((row, index) => {
                  return (
                    <TableRow hover key={index}>
                      <TableCell className={tableStyle.bodyCell}>{getAlmKindText(row.ALM_SMM_DAT.ALM_KIND)}</TableCell>
                      <TableCell className={tableStyle.bodyCell}>{row.ALM_SMM_DAT.ITM_NAME}</TableCell>
                      <TableCell className={tableStyle.bodyCell}>{row.ALM_KIND_SET == null ? "" : row.ALM_KIND_SET.TYP_NAME}</TableCell>
                      <TableCell className={tableStyle.bodyCell}>{row.ALM_SMM_DAT.MESSAGE}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            disabled={!buttonEnable}
            disableElevation
            onClick={() => {
              props.onClose();
            }}
          >
            {t('IotDevListStatErrorDialog.閉じる', '閉じる')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default IotDevListStatErrorDialog;